// extracted by mini-css-extract-plugin
export var parcelRow = "_rk-0";